import { useState, useEffect, useCallback } from "react";
import { getSocket } from "../socket";
import { publicRequest } from "../requestMethods";


export function useOnlineStatus(currentUserId, userIds = []) {
  const [onlineSet, setOnlineSet] = useState(new Set());
  const userIdsKey = userIds.join(",");


  const fetchInitial = useCallback(async () => {
    if (!userIdsKey) return;
    try {
      const res = await publicRequest.get(`/online-status?ids=${userIdsKey}`);
      const online = new Set(Object.entries(res.data).filter(([, v]) => v).map(([k]) => k));
      setOnlineSet(online);
    } catch {  }
  }, [userIdsKey]);

  useEffect(() => {
    fetchInitial();
  }, [fetchInitial]);


  useEffect(() => {
    if (!currentUserId) return;
    const socket = getSocket(currentUserId);

    const handleOnline = (userId) => {
      setOnlineSet((prev) => {
        const next = new Set(prev);
        next.add(String(userId));
        return next;
      });
    };

    const handleOffline = (userId) => {
      setOnlineSet((prev) => {
        const next = new Set(prev);
        next.delete(String(userId));
        return next;
      });
    };

    socket.on("user_online", handleOnline);
    socket.on("user_offline", handleOffline);

    return () => {
      socket.off("user_online", handleOnline);
      socket.off("user_offline", handleOffline);
    };
  }, [currentUserId]);

  return onlineSet;
}
